export const reportsList = [
  {
    key:'1',
    panelHeader:'accounting reports',
    children:[
      // {
      //   key: "11",
      //   header: "Cash Flow",
      //   description:
      //     "Track the net change in GL account along with incomings and outgoings of cash within a given time period. This report displays the net change in income, expense, and other GL accounts set to be included, along with the total cash flow for the period. Primarily used by presidents and accountants.",
      //   favorite: false,
      // },
      // {
      //   key: "12",
      //   header: "Cash Flow - 12 Month",
      //   description:
      //     "Track the net change in GL account along with the incomings and outgoings of cash month-over-month for a 12 month period. This report displays the net change in income, expense, and other GL accounts set to be included, along with the total cash flow for the period. Primarily used by presidents and accountants.",
      //   favorite: true,
      // },
      // {
      //   key: "13",
      //   header: "Cash Flow - Property Comparison",
      //   description:
      //     "Compare the net change in GL account along with incomings and outgoings of cash within a given time period for up to 950 properties. This report displays the net change in income, expense, and other GL accounts set to be included, along with the total cash flow for the period. Primarily used by presidents and accountants.",
      //   favorite: false,
      // },
      // {
      //   key: "14",
      //   header: "Cash Flow Detail",
      //   description:
      //     "Review in detail the net change in GL accounts in addition to the incomings and outgoings of cash within a given period. You'll find all transactions that occurred within the period that make up the cash flow report. Primarily used by presidents and accountants.",
      //   favorite: false,
      // },
      // {
      //   key: "15",
      //   header: "General Ledger",
      //   description:
      //     "Audit all financial activity booked on your properties. The general ledger is the most comprehensive accounting report in AppFolio. It displays every debit, credit and running balance for every GL account in your chart of accounts. Primarily used by presidents and accountants.",
      //   favorite: false,
      // },
    ]
  },
  {
    key:'2',
    panelHeader:'Diagnostic Reports',
    children:[
      // {
      //   key: "21",
      //   header: "Email Delivery Errors",
      //   description:
      //     "View all emails to residents that have delivery errors within the period data is available. Primarily used by presidents, regional managers, community managers and support staff.",
      //   favorite: false,
      // },
      // {
      //   key: "22",
      //   header: "Late Fee Policy Comparison",
      //   description:
      //     "View and compare all of your late fee policies in one place. Inside, you'll see each policy that your property or current resident has had, line by line, and the date range that the policy was being used. Property-specific policies do not show an entry in the Resident column.",
      //   favorite: true,
      // },
    ]
  },
  {
    key:'3',
    panelHeader:'Leasing Reports',
    children:[
      // {
      //   key: "21",
      //   header: "Guest Card Inquiries",
      //   description:
      //     "Track prospective renters for your vacancies. Inside you'll find when all inquiries were received, the current status, inquiry source, and last activity type for all guest cards. Primarily used by leasing agents, shows one row per property.",
      //   favorite: false,
      // },
      // {
      //   key: "22",
      //   header: "Lease History",
      //   description:
      //     "Review leases and renewals for a tenant. Inside, you'll find the lease dates, rent amounts, and renewal statuses across their entire tenancy. The rent value is calculated based on recurring charges in the Rent Income key accounts at the start of the lease term.",
      //   favorite: false,
      // },
      // {
      //   key: "23",
      //   header: "Premium Leads Billing Detail",
      //   description:
      //     "Clarify your monthly spend on Premium Leads. Inside, you'll find the name of the prospect, the date you were charged or refunded, the amount charged (or refunded), the property entered on the guest card. Primarily used by leasing agents.",
      //   favorite: false,
      // },
      // {
      //   key: "24",
      //   header: "Guest Card Interests",
      //   description:
      //     "Track prospective renters for your vacancies. Inside you'll find when all interests were received, the current status, inquiry source, and last activity type for all guest cards. Primarily used by leasing agents.",
      //   favorite: false,
      // },
      // {
      //   key: "25",
      //   header: "Leasing Agent Performance",
      //   description:
      //     "Stay informed about how effectively your leasing agents are moving through the leasing funnel. This report shows the number of showings, rental applications and converted tenants associated with a guest card. Primarily used by regional managers, property managers, and leasing agents.",
      //   favorite: false,
      // },
      // {
      //   key: "26",
      //   header: "Prospect Source Tracking",
      //   description:
      //     "Optimize your marketing efforts by determining which marketing sources drive the most leads. This report shows guest cards (leads), showings, rental applications (approved and denied), and converted tenants have been generated by each marketing source. Primarily used by leasing agents and property managers.",
      //   favorite: false,
      // },
      // {
      //   key: "27",
      //   header: "Inactive Guest Card Interests",
      //   description:
      //     "Track the reasons for why prospective renters do not move forward with their guest cards.",
      //   favorite: false,
      // },
      // {
      //   key: "28",
      //   header: "Leasing Summary",
      //   description:
      //     "Stay on top of your leasing funnel by unit type. This report displays a list of unit types and leasing events such as guest cards received, rental applications received, move ins completed etc. Primarily used by regional manager, property managers, and leasing agents.",
      //   favorite: false,
      // },
      // {
      //   key: "29",
      //   header: "Renewal Summary",
      //   description:
      //     "Track the status of all upcoming and in-progress lease renewals offers. Inside, you'll find the tenant name, their lease dates, rent amounts, renewal status and current lease term. Primarily used by property managers.",
      //   favorite: false,
      // },
      // {
      //   key: "210",
      //   header: "Lease Expiration Detail By Month",
      //   description:
      //     "Stay on top of expiring leases to prepare renewal offers or begin the turnover process. Run this report to view all tenants with expiring leases across properties grouped by month of lease expiration. Primarily used by property managers and leasing agents.",
      //   favorite: false,
      // },
      // {
      //   key: "211",
      //   header: "Occupancy Summary",
      //   description:
      //     "Stay on top of your portfolio's occupancy percentage. This report displays a list of unit types and occupancy statistics, such as number of occupied units, percent of units occupied, etc. Primarily used by property managers and leasing agents.",
      //   favorite: false,
      // },
      // {
      //   key: "212",
      //   header: "Rental Applications",
      //   description:
      //     "Optimize your marketing efforts by determining which marketing sources drive the most converted applications. See when the application was received, a desired move in, lead source, application status, and whether the application has been screened. Primarily used by property managers and leasing agents.",
      //   favorite: false,
      // },
      // {
      //   key: "213",
      //   header: "Lease Expiration Summary By Month",
      //   description:
      //     "Stay on top of expiring leases to prepare renewal offers or begin the turnover process. The report lists each property, the number of units, all leases expiring per month, and a total of all expiring leases for the year. Primarily used by property managers and leasing agents.",
      //   favorite: false,
      // },
      // {
      //   key: "214",
      //   header: "Owner Leasing",
      //   description:
      //     "View the leasing funnel for each unit in a property. Leasing events include number of inquiries received, showings, applications, and converted tenants. Primarily used by leasing agents.",
      //   favorite: false,
      // },
    ]
  },
];

export const reports = [
  {
    label: "Accounting Reports",
    children: [
      {
        title: 'Balance Sheet',
        value: 'Balance Sheet',
      },
      {
        title: 'Cash Flow',
        value: 'Cash Flow',
      },
    ],
  },
  {
    label: 'Leasing Reports',
    children: [
      {
        title: 'Owner Leasing',
        value: 'Owner Leasing',
      },
      {
        title: 'Unit Vacancy Detail',
        value: 'Unit Vacancy Detail',
      },
      {
        title: 'Lease Expiration Date by Month',
        value: 'Lease Expiration Date by Month',
      },
    ]
  },
];